/**
 * GİZLİLİK PERDESİ TANISI (01.11.2026): iPhone'un uygulama değiştiricisinde
 * perde görünmüyordu. Adrese `?tani=1` eklenince tarayıcının geçişte hangi
 * sinyali hangi sırayla verdiği (olay adı, an, görünürlük, odak) bu sekmenin
 * oturum deposunda tutulur ve Ayarlar › Kasa kilidi'nde gösterilir. Yalnızca
 * cihazda; merkeze gitmez, portföy bilgisi içermez.
 */

const ISARET = "parafon.perdeTanisi";
const KAYIT = "parafon.perdeTanisi.kayit";
const EN_COK = 40;

export interface TaniKaydi {
  /** Olay adı (visibilitychange, blur, focus, pagehide, pageshow, freeze, resume). */
  readonly o: string;
  /** An (ms). */
  readonly t: number;
  /** O andaki görünürlük. */
  readonly g: string;
  /** O anda sayfanın odağı var mı. */
  readonly f: boolean;
}

/** Tanı açık mı: adreste `tani=1` görüldüyse sekme boyunca açık kalır. */
export function taniAcik(): boolean {
  try {
    if (new URLSearchParams(globalThis.location?.search ?? "").get("tani") === "1") {
      globalThis.sessionStorage?.setItem(ISARET, "1");
      return true;
    }
    return globalThis.sessionStorage?.getItem(ISARET) === "1";
  } catch {
    return false;
  }
}

export function taniYaz(olay: string): void {
  try {
    const eski = taniOku();
    const yeni: TaniKaydi = {
      o: olay,
      t: Date.now(),
      g: globalThis.document?.visibilityState ?? "?",
      f: globalThis.document?.hasFocus?.() ?? false,
    };
    globalThis.sessionStorage?.setItem(KAYIT, JSON.stringify([...eski, yeni].slice(-EN_COK)));
  } catch {
    /* depolama kapalıysa tanı yok */
  }
}

export function taniOku(): TaniKaydi[] {
  try {
    const v = JSON.parse(globalThis.sessionStorage?.getItem(KAYIT) ?? "[]") as unknown;
    return Array.isArray(v) ? (v as TaniKaydi[]) : [];
  } catch {
    return [];
  }
}

export function taniSil(): void {
  try {
    globalThis.sessionStorage?.removeItem(KAYIT);
  } catch {
    /* yok say */
  }
}
